import { RequestHeaderDetail, User } from '@/api'
import { RequestTypes } from '@/constants/enums'
import { B_WS_BEFORE, B_WS_RECV, P_PD_RECV, P_WS_BEFORE, P_WS_RECV } from '@/constants/statuses'

/**
 * 申請基本ロジック
 */
export default class RequestHeaderLogic {
  private requestHeader: RequestHeaderDetail
  constructor(requestHeader: RequestHeaderDetail) {
    this.requestHeader = requestHeader
  }

  /**
   * 事前協議の日程回答が可能か
   * @returns
   */
  public canAnswerProximityPriorDiscussionSchedule(): boolean {
    if (this.requestHeader.proximity == null) {
      // 申請基本でない場合はfalse
      return false
    }
    const status = this.requestHeader.proximity.prior_discussion_status
    // 開始前～日程受信なら可能
    return status != null && status <= P_PD_RECV
  }

  /**
   * 近接工事の現地立会日程回答が可能か
   * @returns
   */
  public canAnswerProximitySchedule(): boolean {
    if (this.requestHeader.proximity == null) {
      // 申請基本でない場合はfalse
      return false
    }
    const status = this.requestHeader.proximity.witness_status
    // 日程送信後～日程受信なら可能
    return status != null && status > P_WS_BEFORE && status <= P_WS_RECV
  }

  /**
   * 境界立会の現地立会日程回答が可能か
   * @returns
   */
  public canAnswerBoundarySchedule(): boolean {
    if (this.requestHeader.boundary == null) {
      // 申請基本でない場合はfalse
      return false
    }
    const status = this.requestHeader.boundary.witness_status
    // 日程送信後～日程受信なら可能
    return status != null && status > B_WS_BEFORE && status <= B_WS_RECV
  }

  /**
   * 担当保守区かどうかをチェックする
   * @param user
   * @returns
   */
  public isManagerDepartmentUser(user: User): boolean {
    // - 近接工事の場合: JRQC近接協議担当者 OR 担当保守区 用地担当以外
    // - 境界立会の場合: JRQC用地（本部） OR 担当保守区 近接担当以外
    if (this.requestHeader.is_tanto_department_login_user) {
      return true
    }
    if (this.requestHeader.request_type === RequestTypes.PROXIMITY) {
      // 近接の場合はJRQC近接担当かどうか
      return user.is_jrqc_proximity
    } else if (this.requestHeader.request_type === RequestTypes.BOUNDARY) {
      // 境界の場合はJRQC用地担当かどうか
      return user.is_jrqc_land_main
    }
    throw new Error(`不正な申請種別です。 request_header_id: ${this.requestHeader.request_header_id}`)
  }

  /**
   * スケジュール調整可能なユーザーであるかをチェックする
   * @param user
   * @returns
   */
  public isScheduleAdjustUser(user: User): boolean {
    // - 近接工事の場合: 担当保守区 or JRQC近接担当
    // - 境界立会の場合: 担当保守区 or JRQC用地（本部）
    if (user.section.department.department_code === this.requestHeader.department_code) {
      return true
    }
    if (this.requestHeader.request_type === RequestTypes.PROXIMITY) {
      // 近接の場合はJRQC近接担当かどうか
      return user.is_jrqc_proximity
    } else if (this.requestHeader.request_type === RequestTypes.BOUNDARY) {
      // 境界の場合はJRQC用地担当かどうか
      return user.is_jrqc_land_main
    }

    throw new Error(`不正な申請種別です。 request_header_id: ${this.requestHeader.request_header_id}`)
  }
}
